<template>
    <div id="pay">
        <transition name="fade">
            <Loading v-if="isLoading" />
        </transition>
        <gotop/>
        <step :stepNumber="5"/>
        <div class="content">
            <div class="container">
                <h2 class="title2">繳費</h2>
                <h3 class="blueTitle">繳費資料</h3>
                <ul class="paymentList">
                    <li><span>總保費：$</span><span class="clarity-unmask">{{ formatMoney(calculate) }}</span></li>
                    <li><span>付款人姓名：</span><span id="payName" class="tlf_r_f1 clarity-mask wordBreakAll">{{ applicantData.applicantName }}</span></li>
                    <li><span>身分證字號：</span><span id="payIdNo" class="tlf_n_l5 clarity-mask">{{ applicantData.applicantIdNo }}</span></li>
                    <li>
                        <h3 class="blueTitle">繳費方式</h3>
                        <div class="radioLine">
                            <input type="radio" name="payment" id="payment1" value="1" checked="checked"
                                   v-model="payment">
                            <label for="payment1">
                                <span></span>
                                信用卡繳費 <img src="../assets/visa.svg" alt="" class="inline">
                            </label>
                        </div>
                        <div class="radioLine" v-if="policyType === 'INSURE' && atmStatus">
                            <input type="radio" name="payment" id="payment2" value="2" v-model="payment">
                            <label for="payment2">
                                <span></span>
                                帳戶扣款
                            </label>
                        </div>
                        <div class="credit" v-if="payment === '1' && policyType === 'INSURE'">
                            <div class="oneline">
                                <div class="inputControl">
                                    <div class="inputTitle">卡號</div>
                                    <div class="inputStyle creditInput clarity-mask">
                                        <input type="tel" pattern="\d*" maxlength="4" placeholder="．．．．" class="tlf_n_all"
                                               name="creditcardSub"
                                               v-for="(item, index) in creditList" v-model="item.val" value="" :id="'creditNo'+index"
                                               @keyup="nextFocus($event, index)" :key="index">
                                    </div>
                                </div>
                            </div>
                            <div class="inline">
                                <div class="inputControl">
                                    <div class="inputTitle">有效期限</div>
                                    <div class="inputStyle expiryInput clarity-mask">
                                        <input type="tel" id="expiryMonth" pattern="\d*" maxlength="2" placeholder="MM"
                                               name="creditcardSub" v-model="expiryMonth" @keyup="nextFocus($event, 4)">
                                        <span>/</span>
                                        <input type="tel" id="expiryYear" pattern="\d*" maxlength="2" placeholder="YY"
                                               name="creditcardSub" v-model="expiryYear" @keyup="nextFocus($event, 5)">
                                    </div>
                                </div>
                                <div class="inputControl">
                                    <div class="inputTitle">安全驗證碼</div>
                                    <input type="tel" id="CVV" pattern="\d*" maxlength="4" placeholder="．．．．"
                                           class="inputStyle clarity-mask" name="creditcardSub" v-if="aecard"
                                           @keyup="nextFocus($event, 6)" v-model="creditCvv">
                                    <input type="tel" id="CVV" pattern="\d*" maxlength="3" placeholder="．．．"
                                           class="inputStyle clarity-mask" name="creditcardSub" v-else
                                           @keyup="nextFocus($event, 6)" v-model="creditCvv">
                                </div>
                            </div>
                        </div>
                        <div class="bankPay" v-if="policyType === 'INSURE' && atmStatus">
                            <div class="bankAccount" v-if="payment === '2'">

                                <div class="inputControl">
                                    <div class="inputTitle">轉出銀行</div>
<!--                                    <select class="inputStyle arrow" v-model="atmBank">-->
<!--                                        <option value="" selected disabled>請選擇銀行</option>-->
<!--                                        <option v-for="(bank, index) in bankListSelect"-->
<!--                                                :value="bank.id + '-' + bank.bankCode">-->
<!--                                            {{ bank.bankName }}-->
<!--                                        </option>-->
<!--                                    </select>-->
                                    <model-select :options="bankOptions"
                                                  class="inputStyle arrow selectSearch"
                                                  v-model="atmBank"
                                                  placeholder="請選擇銀行"
                                    >
                                    </model-select>
                                </div>
                                <div class="inline">
                                    <div class="inputControl">
                                        <div class="inputTitle">轉出帳戶</div>
                                        <input type="text" pattern="\d*" placeholder="請輸入銀行帳號" class="inputStyle tlf_n_all" id="bankNo"
                                               v-model="atmAccount">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="credit tappay" v-show="policyType === 'APPLY'">
                            <div class="oneline">
                                <div class="form-group card-number-group inputControl">
                                    <label for="card-number" class="inputTitle">卡號 (<span id="cardtype">{{ cardType
                                        }}</span>)
                                    </label>
                                    <div class="form-control card-number inputStyle tlf_n_all" id="card-number"></div>
                                </div>
                            </div>
                            <div class="inline">
                                <div class="form-group expiration-date-group inputControl">
                                    <label for="expiration-date" class="inputTitle">有效期限</label>
                                    <div class="form-control expiration-date inputStyle" id="card-expiration-date"></div>
                                </div>
                                <div class="form-group cvc-group inputControl">
                                    <label for="cvc" class="inputTitle">安全驗證碼</label>
                                    <div class="form-control cvc inputStyle" id="card-ccv"></div>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>

            </div>
        </div>
        <div class="btnArea">
            <div class="anotherBtn">
                <button class="btn confirm pay_go_accu" @click="goTapPay" v-if="policyType === 'APPLY'" alt="網要繳費">繳費</button>
                <button class="btn confirm pay_go_accu" @click="goInsureCredit" v-if="payment === '1' && policyType === 'INSURE'"
                        alt="網投信用卡繳費">繳費
                </button>
                <button class="btn confirm pay_go_accu" @click="goInsureEbill" v-if="payment === '2' && policyType === 'INSURE' && atmStatus"
                        alt="網投全國繳費">繳費
                </button>
            </div>
        </div>
    </div>
</template>


<script setup>
        import gotop from "@/components/gotop.vue";
        import step from "@/components/step.vue";
        import {getApi, postApi} from "@/utils/callApi";
        import _ from "lodash";
        import "@/plugins/tappay.js";
        import LoadData from "@/utils/loadData";
        import Loading from "@/components/loading.vue";
        import {ModelSelect} from 'vue-search-select'
        import {popUp} from "@/utils/popUp";
        import {onMounted, ref} from "vue";
        import {useRouter} from "vue-router";
        import gtm from "@/utils/gtmDataLayer";
        import Swal from "sweetalert2";
        import apiConfig from "@/utils/apiConfig";
        import $ from "jquery";

        const router = useRouter();

        let jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));//JWT
        let planCode = sessionStorage.getItem("confirmPlanCode");//方案代號
        let confirmStorage = JSON.parse(sessionStorage.getItem("confirmStorage"));//取得最終正確資料
        let applicationNo = sessionStorage.getItem("applicationNo");

        const isLoading = ref(false);
        //const allowBack = ref(true);//不允許返回
        const aecard = ref(false);//是否是AE卡
        const atmStatus = ref(true);//允許全國繳費 ture:允許 false:不允許
        const bankOptions = ref([]);//顯示銀行下拉清單
        const payment = ref("1");//網投繳款方式(信用卡 1或全國繳費 2)
        const creditList = ref([{val: ""}, {val: ""}, {val: ""}, {val: ""}]);//信用卡卡號
        const applicantData = ref({applicantIdNo: "",applicantName: ""});//要保人資訊
        //const focused = ref(false);//卡號底線樣式
        //const focused2 = ref(false);//有效期限底線樣式
        const calculate = ref("");//總保費
        const policyType = ref(sessionStorage.getItem("confirmPolicyType"));//網投或網要
        const creditCvv = ref("");//安全驗證碼
        const expiryYear = ref("");//有效年
        const expiryMonth = ref("");//有效月
        const atmBank = ref("");//全國繳費網銀行
        const atmAccount = ref("");//全國繳費網帳號
        let cardType = ref("信用卡");//


        // 總保費加上千分位號","
        const formatMoney = (value) => {
            if (value === null || value === undefined) return null;
            return parseFloat(value).toLocaleString("zh-TW", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 50,
            });
        };
        //取得ATM狀態
        const getTravelAtmStatus = () => {
            getApi(apiConfig.getTravelAtmStatus).then((response) => {
                atmStatus.value = response.data.data;
            }).catch(() => {
                //載入錯誤一律不允許
                atmStatus.value = false;
            })
        }
        //自動TAB
        const nextFocus = _.debounce( (event, index) => {
            const dom = document.getElementsByName(event.target.name);

            const currInput = dom[index];
            const nextInput = dom[index + 1];
            const lastInput = dom[index - 1];

            const numLength = dom[0].value.length + dom[1].value.length + dom[2].value.length+dom[3].value.length;
            currInput.value = currInput.value.replace(/[^\d]/g, '')
            if (currInput.value.length === currInput.maxLength && nextInput != null) {
                nextInput.focus();
            }
            if (currInput.value.length === 0 && lastInput != null) {
                lastInput.focus();
            }

            onlyNum(event);

            if(index <= 3 && numLength === 15){ // 判斷AEcard
                const numFront = dom[0].value.toString().substring(0,2);
                if(numFront === '34' || numFront === '37'){
                    aecard.value = true
                }
            }else if(numLength < 15 ||numLength > 15){
                aecard.value = false
                if(dom[6].value.length === 4){
                    creditCvv.value = dom[6].value.toString().slice(0, -1)
                }
            }
        }, 50)
        //控制只能輸入數字
        const onlyNum = (event) =>{
            event.target.value = event.target.value.replace(/[^\d]/g, '')
        }
        //載入confirmStorage
        const loadStorage = ()=> {
            if (confirmStorage != null) {
                if (confirmStorage.applicantData != null) {
                    applicantData.value = confirmStorage.applicantData;
                }
                if (confirmStorage.totalPremium != null) {
                    calculate.value = confirmStorage.totalPremium;
                }
            }
        }
        //確認登入
        const checkLogin = () => {
            let checkPage = true;
            let message = [];
            if (applicationNo === "" || applicationNo == null) {
                checkPage = false;
                message.push('流程錯誤，請重新投保');
            }
            if (jwtInfo == null) {
                checkPage = false;
                message.push('頁面逾期，請重新投保');
            }
            if (checkPage) {
                loadStorage();
            } else {
                Swal.fire({
                    title: "頁面錯誤",
                    confirmButtonText: "確定",
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>'+ message +'</p>'
                }).then(() => {
                    router.push('/');
                });
            }
        }
        const getTappayKey = () => {
            jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            if (jwtInfo != null) {
                postApi(apiConfig.getTappayKey, jwtInfo.token)
                    .then((response) => {
                        const tapPayData = response.data;
                        if (tapPayData.code === 200) {
                            // eslint-disable-next-line no-undef
                            TPDirect.setupSDK(tapPayData.data.tappayAppId, tapPayData.data.tappayAppKey, tapPayData.data.tappayServerType);
                            // eslint-disable-next-line no-undef
                            TPDirect.card.setup({
                                fields: {
                                    number: {
                                        element: '#card-number',
                                        placeholder: '．．．．  ．．．．  ．．．．  ．．．．'
                                    },
                                    expirationDate: {
                                        element: '#card-expiration-date',
                                        placeholder: 'MM / YY'
                                    },
                                    ccv: {
                                        element: '#card-ccv',
                                        placeholder: '．．．'
                                    }
                                },
                                styles: {
                                    'input': {
                                        'color': 'gray',
                                        'font-size':'16px'
                                    },
                                    'input.ccv': {
                                        // 'font-size': '16px'
                                    },
                                    ':focus': {
                                        'color': 'black'
                                    },
                                    '.valid': {
                                        'color': '#005bac'
                                    },
                                    '.invalid': {
                                        'color': '#EE5B6E'
                                    },
                                    '@media screen and (max-width: 400px)': {
                                        'input': {
                                            'color': 'orange'
                                        }
                                    }
                                },
                                // 此設定會顯示卡號輸入正確後，會顯示前六後四碼信用卡卡號
                                isMaskCreditCardNumber: true,
                                maskCreditCardNumberRange: {
                                    beginIndex: 6,
                                    endIndex: 11
                                }
                            })
                            // listen for TapPay Field
                            // eslint-disable-next-line no-undef
                            TPDirect.card.onUpdate(function (update) {
                                /* Disable / enable submit button depend on update.canGetPrime  */
                                /* ============================================================ */

                                // update.canGetPrime === true
                                //     --> you can call TPDirect.card.getPrime()
                                // const submitButton = document.querySelector('button[type="submit"]')
                                if (update.canGetPrime) {
                                    // submitButton.removeAttribute('disabled')
                                    $('button[type="submit"]').removeAttr('disabled')
                                } else {
                                    // submitButton.setAttribute('disabled', true)
                                    $('button[type="submit"]').attr('disabled', true)
                                }
                                /* Change card type display when card type change */
                                /* ============================================== */

                                // cardTypes = ['visa', 'mastercard', ...]
                                cardType.value = update.cardType === 'unknown' ? '信用卡' : update.cardType;
                                if(cardType.value === 'amex'){ //判斷是否為AE卡
                                    aecard.value = true
                                }

                            })
                        } else {
                            Swal.fire({
                                title: "填寫資料錯誤",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="error.svg" alt="error"><p>' + response.message + '</p>',
                                customClass: {
                                    closeButton: "pay_fail_close_accu"
                                }
                            });
                        }
                    }).catch(() => {
                    Swal.fire({
                        title: "資料錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg" alt="error"><p>檢查資料連線錯誤</p>',
                        customClass: {
                            closeButton: "pay_fail_close_accu"
                        }
                    });
                });
            } else {
                Swal.fire({
                    title: "尚未登入",
                    confirmButtonText: "確定",
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>請進行登入後繼續</p>'
                }).then(() => {
                    router.push('/');
                });
            }
        }
        //網要tappay
        const goTapPay = _.debounce(()=> {
            isLoading.value = true;

            // eslint-disable-next-line no-undef
            const tappayStatus = TPDirect.card.getTappayFieldsStatus();
            //Check TPDirect.card.getTappayFieldsStatus().canGetPrime before TPDirect.card.getPrime
            if (tappayStatus.canGetPrime === false) {
                Swal.fire({
                    title: "填寫資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>請填入正確信用卡資訊</p>',
                    customClass: {
                        closeButton: "pay_fail_close_accu"
                    }
                });
                isLoading.value = false;
            }
            //Get prim
            // eslint-disable-next-line no-undef
            TPDirect.card.getPrime(function (result) {
                if (result.status !== 0) {
                    Swal.fire({
                        title: "填寫資料錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg" alt="error"><p>請填入正確信用卡資訊</p>',
                        customClass: {
                            closeButton: "pay_fail_close_accu"
                        }
                    });
                    isLoading.value = false;
                    return
                }
                let prime = result.card.prime;
                // 信用卡付款
                goInsureTapPay(prime);
            });

        }, 50)
        const goInsureTapPay = (prime) => {
            const applicantName = applicantData.value.applicantName;
            const applicantIdNo = applicantData.value.applicantIdNo;
            const paymentAmount = calculate.value;

            const data = {
                'applicationNo': applicationNo,//要保序號
                'applicantIdNo': applicantIdNo,//要保人ID
                'applicantName': applicantName,//要保人姓名
                'creditNo': prime,//信用卡卡號
                'paymentType': "C",//付款方式
                'paymentAmount': paymentAmount,//付款金額
                'isAECard':aecard.value, //是否為AE卡
                'trackingCode': sessionStorage.getItem("trackingCode"),
            }
            isLoading.value = true;
            jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            if (jwtInfo != null) {
                postApi(apiConfig.insurancePay, jwtInfo.token, null, null, data)
                    .then((response) => {
                        const checkPayData = response.data;
                        if (checkPayData.code === 200) {
                            isLoading.value  = false;
                            sendDataLayer();
                            router.push("/complete");
                        }else if(checkPayData.code === 300){
                            Swal.fire({
                                title: "公會連線失敗",
                                showConfirmButton: true,
                                showCloseButton: true,
                                html: '<img src="error.svg" alt="error"><p>'+ "很抱歉，目前「保險業通報作業系統」通報連線失敗，無法受理您本次要保，請您稍後再試；本次已取得之信用卡授權將取消 / 已收受的銀行扣款將於工作日進行退款，造成您的不便，敬請見諒！" +'</p>'
                            }).then(() => {
                                isLoading.value  = false;
                                router.push('/');
                            });
                            isLoading.value  = false;
                        }
                        else {
                            Swal.fire({
                                title: "填寫資料錯誤",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="error.svg" alt="error"><p>'+ checkPayData.message +'</p>',
                                customClass: {
                                    closeButton: "pay_fail_close_accu"
                                }
                            });
                            isLoading.value = false;
                        }
                    }).catch(() => {
                    Swal.fire({
                        title: "資料錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg" alt="error"><p>付款連線錯誤</p>',
                        customClass: {
                            closeButton: "pay_fail_close_accu"
                        }
                    });
                    isLoading.value  = false;
                });
            } else {
                Swal.fire({
                    title: "尚未登入",
                    confirmButtonText: "確定",
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>請進行登入後繼續</p>',
                }).then(() => {
                    isLoading.value  = false;
                    router.push('/login');
                });
                isLoading.value  = false;
            }

        }
        //網投全國繳費付款
        const goInsureEbill = _.debounce( () => {

            const applicantIdNo = applicantData.value.applicantIdNo;
            const clientAtmNo = atmAccount.value;
            const clientBankNo = atmBank.value;
            const paymentAmount = calculate.value;

            let checkFlag = true;
            let errorMsg = [];

            if (clientAtmNo === "" || clientAtmNo == null) {
                checkFlag = false;
                errorMsg.push("請輸入轉出銀行帳號");
            }
            if (clientBankNo === "" || clientBankNo == null) {
                checkFlag = false;
                errorMsg.push("請選擇轉出銀行");
            }

            if (checkFlag) {
                isLoading.value = true;
                const data = {
                    'applicationNo': applicationNo,//要保序號
                    'applicantIdNo': applicantIdNo,//要保人身分證字號
                    'clientAtmNo': clientAtmNo,//帳號
                    'clientBankNo': clientBankNo,//銀行
                    'paymentType': "A",//付款方式
                    'paymentAmount': paymentAmount,//付款金額
                    'trackingCode': sessionStorage.getItem("trackingCode"),
                }
                jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
                if (jwtInfo != null) {
                    postApi(apiConfig.insuranceEbill, jwtInfo.token, null, null, data)
                        .then((response) => {
                            const checkPayData = response.data;
                            if (checkPayData.code === 200) {
                                isLoading.value = false;
                                sendDataLayer();
                                sendClarityEvent('完成投保', data.applicationNo);
                                router.push("/complete");
                            }else if(checkPayData.code === 300){
                                Swal.fire({
                                    title: "公會連線失敗",
                                    showConfirmButton: true,
                                    showCloseButton: true,
                                    html: '<img src="error.svg" alt="error"><p>'+ "很抱歉，目前「保險業通報作業系統」通報連線失敗，無法受理您本次要保，請您稍後再試；本次已取得之信用卡授權將取消 / 已收受的銀行扣款將於工作日進行退款，造成您的不便，敬請見諒！" +'</p>'
                                }).then(() => {
                                    isLoading.value = false;
                                    router.push('/');
                                });
                                isLoading.value = false;
                            }
                            else {
                                Swal.fire({
                                    title: "填寫資料錯誤",
                                    showConfirmButton: false,
                                    showCloseButton: true,
                                    html: '<img src="error.svg" alt="error"><p>'+ checkPayData.message +'</p>',
                                    customClass: {
                                        closeButton: "pay_fail_close_accu"
                                    }
                                });
                                isLoading.value = false;
                            }
                        }).catch(() => {
                        Swal.fire({
                            title: "資料錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p>付款連線錯誤</p>',
                            customClass: {
                                closeButton: "pay_fail_close_accu"
                            }
                        });
                        isLoading.value = false;
                    });
                } else {
                    Swal.fire({
                        title: "尚未登入",
                        confirmButtonText: "確定",
                        showCloseButton: true,
                        html: '<img src="error.svg" alt="error"><p>請進行登入後繼續</p>',
                    }).then(() => {
                        isLoading.value = false;
                        router.push('/login');
                    });
                }
            } else {
                Swal.fire({
                    title: "填寫資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>'+ errorMsg +'</p>',
                    customClass: {
                        closeButton: "pay_fail_close_accu"
                    }
                });
                isLoading.value = false;
            }
        }, 200)
        //信用卡付款
        const goInsureCredit = _.debounce(() => {
            const applicantName = applicantData.value.applicantName;
            const applicantIdNo = applicantData.value.applicantIdNo;
            const creditNo = creditList.value[0].val + creditList.value[1].val + creditList.value[2].val + creditList.value[3].val;
            const creditEffect = expiryYear.value + expiryMonth.value;
            const paymentAmount = calculate.value;

            let checkFlag = true;
            let errorMsg = [];

            if (creditNo === "" || creditNo == null) {
                checkFlag = false;
                errorMsg.push('請輸入完整信用卡號');
            }
            if (creditCvv.value === "" || creditCvv.value == null) {
                checkFlag = false;
                errorMsg.push('請輸入驗證碼');
            }
            if (creditEffect === "" || creditEffect == null) {
                checkFlag = false;
                errorMsg.push('請輸入有效日');
            }

            if (checkFlag) {
                isLoading.value = true;
                const data = {
                    'applicationNo': applicationNo,//要保序號
                    'applicantIdNo': applicantIdNo,//要保人ID
                    'applicantName': applicantName,//要保人姓名
                    'creditNo': creditNo,//信用卡卡號
                    'creditCvv': creditCvv.value,//信用卡驗證碼
                    'creditEffect': creditEffect,//信用卡有效日
                    'paymentType': "C",//付款方式
                    'paymentAmount': paymentAmount,//付款金額
                    'trackingCode': sessionStorage.getItem("trackingCode"),
                }
                jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
                if (jwtInfo != null) {
                    postApi(apiConfig.insurancePay, jwtInfo.token, null, null, data)
                        .then((response) => {
                            const checkPayData = response.data;
                            if (checkPayData.code === 200) {
                                isLoading.value = false;
                                sendDataLayer();
                                sendClarityEvent('完成投保', data.applicationNo);
                                router.push("/complete");
                            }else if(checkPayData.code === 300){
                                Swal.fire({
                                    title: "公會連線失敗",
                                    showConfirmButton: true,
                                    showCloseButton: true,
                                    html: '<img src="error.svg" alt="error"><p>'+ "很抱歉，目前「保險業通報作業系統」通報連線失敗，無法受理您本次要保，請您稍後再試；本次已取得之信用卡授權將取消 / 已收受的銀行扣款將於工作日進行退款，造成您的不便，敬請見諒！" +'</p>'
                                }).then(() => {
                                    isLoading.value = false;
                                    router.push('/');
                                });
                                isLoading.value = false;
                            }
                            else {
                                Swal.fire({
                                    title: "填寫資料錯誤",
                                    showConfirmButton: false,
                                    showCloseButton: true,
                                    html: '<img src="error.svg" alt="error"><p>'+ checkPayData.message +'</p>',
                                    customClass: {
                                        closeButton: "pay_fail_close_accu"
                                    }
                                });
                               isLoading.value = false;
                            }
                        }).catch(() => {
                        Swal.fire({
                            title: "資料錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p>付款連線錯誤</p>',
                            customClass: {
                                closeButton: "pay_fail_close_accu"
                            }
                        });
                        isLoading.value = false;
                    });
                } else {
                    Swal.fire({
                        title: "尚未登入",
                        confirmButtonText: "確定",
                        showCloseButton: true,
                        html: '<img src="error.svg" alt="error"><p>請進行登入後繼續</p>',
                    }).then(() => {
                        isLoading.value = false;
                        router.push('/login');
                    });
                }
            } else {
                Swal.fire({
                    title: "填寫資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>'+ errorMsg + '</p>',
                    customClass: {
                        closeButton: "pay_fail_close_accu"
                    }
                });
                isLoading.value = false;
            }


        }, 200)
        const sendDataLayer = () =>{
            gtm.policyEvent('purchase', calculate.value, applicationNo, '一條龍'
                , policyType.value, planCode, 'optional_taiwan', '自行試算');
        }

        const sendClarityEvent = (tagName, tagValue) => {
            let fpcInfo = JSON.parse(sessionStorage.getItem('fpcInfo'));
            if(fpcInfo){
                postApi(apiConfig.event, null, null, null, {
                    tagName: tagName,
                    tagValue: tagValue,
                    sessionId: fpcInfo.sessionId,
                    fpc: fpcInfo.fpc,
                    clarityId: fpcInfo.clarityId,
                    insuranceType: "旅平險",
                });
            }
        }
        getTravelAtmStatus();//取得ATM狀態
        checkLogin();//確認登入狀態載入資料

        onMounted(()=>{
            popUp();//公告系統
            gtm.pageViewEvent();//新增pageViewEvent
            if(policyType.value === "APPLY"){
                getTappayKey();
            }
        })
</script>

<style lang="scss">
#pay {
    .radioLine {
        position: relative;
        margin: 10px 0;

        input[type=radio] {
            position: inherit;
        }

        label {
            position: absolute;
            left: 0;

            .link {
                margin: 0 10px;
            }
        }

        img.inline {
            display: inline-block;
            margin: 0;
            vertical-align: middle;
            position: relative;
            top: -2px;
        }

    }

    .paymentList {
      color:$textColor;
        .credit {
            margin: 10px 0;overflow:hidden;
        }

        li {
            margin: 15px 0
        }
        .creditInput {
            text-align: center;
            display: flex;
            justify-content: left;
            padding-left: 10px;

            input {
                border: 0;
                width: 70px;
                text-align: left;
                background: none;
            }
        }

        .expiryInput {
            input {
                width: 30px;
                border: 0;
                background: none;
            }
        }
    }

    .bankAccount {
        margin: 20px 0
    }

    .inputTitle {
        display: block;
        margin: 10px 0;
    }
    .link{
      margin:10px 0;
      display:block;
      @media screen and (max-width: $small) {
        text-align: center;
        margin: 20px auto 0;
        display: block;
      }

    }
    .inline{margin:0;}
}


#cardtype {
    font-weight: 500;
    color: $blue-700;
}

.wordBreakAll{
    word-break: break-all;
}
</style>
